import React from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import SupplierInvoiceForm from './SupplierInvoiceForm';

const NewSupplierInvoicePage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { initialValues, returnTo } = location.state || {};

    if (!initialValues) {
        return <Navigate to="/purchases-module/reception" replace />;
    }

    return (
        <SupplierInvoiceForm
            initialValues={initialValues}
            onSave={() => navigate(returnTo || '/purchases-module/invoices')}
            onCancel={() => navigate(returnTo || '/purchases-module/invoices')}
        />
    );
};

export default NewSupplierInvoicePage;
